'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentSkrillAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.4577 18.4457V39.4924H76.2409V17.4167L70.4577 18.4457Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M62.0162 18.4457L67.7957 17.4167V39.4924H62.0162V18.4457Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M53.7835 39.4924V23.3458H59.5658V39.4924H53.7835Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M53.8233 18.9625C53.8233 17.3964 55.1003 16.126 56.6728 16.126C58.248 16.126 59.5241 17.3964 59.5241 18.9625C59.5241 20.5296 58.248 21.7972 56.6728 21.7972C55.1003 21.7972 53.8233 20.5296 53.8233 18.9625Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M50.5218 23.1091C45.1794 23.2804 42.4651 25.6664 42.4651 30.409V39.4924H48.2956V32.0838C48.2956 29.2455 48.6697 28.0285 52.0563 27.9124V23.1929C51.4867 23.0722 50.5218 23.1091 50.5218 23.1091Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.8344 23.3274C34.7066 23.6498 33.7824 26.2523 31.5414 28.9488V17.4167L25.5739 18.5913V39.4924H31.5414V33.0308C33.2694 35.6103 34.1232 39.4924 34.1232 39.4924H41.2696C40.563 36.5684 37.4709 31.1782 37.4709 31.1782C40.2472 27.6756 41.4649 23.9455 41.6594 23.3274H34.8344Z",
          fill: "#862165"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.5673 25.6296C14.8366 25.5826 13.1438 25.473 13.1438 23.9575C13.1438 22.1288 15.5793 22.1288 16.4933 22.1288C18.101 22.1288 20.1809 22.6005 21.6681 23.0436C21.6681 23.0436 22.496 23.3347 23.2007 23.6314L23.2665 23.6498V18.641L23.1785 18.6143C21.4227 18.0035 19.3845 17.4167 15.6034 17.4167C9.08495 17.4167 6.77538 21.1929 6.77538 24.431C6.77538 26.2956 7.57919 30.6881 15.0422 31.1939C15.6766 31.2326 17.3564 31.3293 17.3564 32.8954C17.3564 34.1888 15.9812 34.9498 13.6689 34.9498C11.1352 34.9498 8.67563 34.3086 7.18284 33.6978V38.8549C9.41832 39.4399 11.939 39.7292 14.8931 39.7292C21.2644 39.7292 24.1203 36.1557 24.1203 32.6126C24.1203 28.5969 20.9264 25.987 15.5673 25.6296Z",
          fill: "#862165"
        }
      )
    ]
  }
);
const VpPaymentSkrillAsset = forwardRef(PaymentSkrillAsset);

export { VpPaymentSkrillAsset as default };
